import React, { useContext } from "react";
import { Context } from "../../utils/context";

// Shows the transaction ID, verification status and screenshot of a QR payment.
// Renders nothing for orders that have no uploaded payment proof.
const PaymentProofInfo = ({ order }) => {
  const { IMG_URL } = useContext(Context);

  const detail = order?.Order_Payment_Detail;

  if (!detail?.payment_proof) return null;

  const status = order?.payment_status;
  const statusText =
    status === "success"
      ? "Verified"
      : status === "failed"
        ? "Failed"
        : "Awaiting verification";
  const statusClass =
    status === "success"
      ? "text-success"
      : status === "failed"
        ? "text-danger"
        : "text-warning";

  return (
    <>
      <div className="order-info">
        <span>
          <b>Transaction ID :</b> {detail?.payment_id || "-"}
        </span>
      </div>
      <div className="order-info">
        <span>
          <b>Payment Status :</b>{" "}
          <span className={statusClass}>{statusText}</span>
        </span>
      </div>
      <div className="order-info">
        <a
          href={IMG_URL + detail.payment_proof}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={IMG_URL + detail.payment_proof}
            alt="Payment screenshot"
            style={{
              width: "90px",
              maxHeight: "120px",
              objectFit: "cover",
              border: "1px solid #dee2e6",
              borderRadius: "6px",
              marginTop: "6px",
            }}
          />
          <div>View payment screenshot</div>
        </a>
      </div>
    </>
  );
};

export default PaymentProofInfo;
